<template>
  <div>
    <FiltersTable
      :getOrderButton="true"
      titleButton="Obtener productos"
      :search="search"
      @onSearch="onSearch"
      @getOrders="getProducts"
    />

    <div v-if="showModalView">
      <PublicationsView :dataView="dataView" @dataView="handleDataView" />
    </div>

    <div v-if="showModalAdd || showModalActive">
      <PublicationsAdd @dataAdd="handleDataAdd" :dataAdd="dataAdd" />
    </div>

    <!-- vs-table stripe :data="orders" pagination max-items="10" multiple v-model="selected" -->
    <!-- Nota, para sst usar <VxTable>, para paginado local usar <vs-table> -->
    <!-- :total="totalItems" :sst="true" @change-page="handleChangePage"-->
    <div v-if="isLoading" class="text-center pt-16">
      <spinner size="50" :line-fg-color="$brandColor"></spinner>
    </div>
    <vs-table
      v-else
      stripe
      :data="publications"
      max-items="30"
      :total="totalItems"
    >
      <template slot="thead">
        <vs-th>Publicación ML</vs-th>
        <vs-th>Producto</vs-th>
        <vs-th>Dimensiones</vs-th>
        <vs-th>Valor</vs-th>
        <vs-th>Destinatario</vs-th>
        <vs-th>Estado flete dinámico</vs-th>
        <vs-th style="width: 150px">Acciones</vs-th>
      </template>

      <template slot-scope="{ data }">
        <vs-tr :key="indextr" v-for="(tr, indextr) in data">
          <vs-td>
            {{ tr.meli_id }}
          </vs-td>
          <vs-td>
            <div class="flex justify-center items-center gap-2">
              <img
                v-if="tr.thumbnail"
                width="60px"
                height="60px"
                :src="tr.thumbnail"
                :alt="tr.title"
              />
              <div>
                {{ tr.title }}
              </div>
            </div>
          </vs-td>
          <vs-td>
            <span v-if="tr.shipping_dimensions">
              {{ tr.shipping_dimensions }}
            </span>
            <span v-else class="text-incomplete" @click="publicationsAdd(tr)">
              Incompleto
            </span>
          </vs-td>
          <vs-td>
            {{ tr.price | toCurrency }}
          </vs-td>
          <vs-td>
            {{ tr.shipping_mode }}
          </vs-td>
          <vs-td>
            <span v-if="tr.status === 'me1'" class="footer_text--cruz-del-sur"
              >Activo</span
            >
            <span v-else class="footer_text--mercado-libre">Inactivo</span>
          </vs-td>
          <vs-td>
            <feather-icon
              @click="publicationsView(tr)"
              icon="EyeIcon"
              svgClasses="h-5 w-5 mx-2 cursor-pointer"
            />
            <feather-icon
              @click="publicationsAdd(tr)"
              icon="BoxIcon"
              svgClasses="h-5 w-5 mx-2 cursor-pointer"
            />
            <feather-icon
              v-if="tr.shipping_dimensions"
              @click="publicationsActive(tr)"
              icon="TruckIcon"
              svgClasses="h-5 w-5 mx-2 cursor-pointer"
            />
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
    <div v-if="publications.length > 0 && !isLoading" class="table-footer">
      <!-- Antes usaba <paginate> de `vuejs-paginate`, un paquete que no esta en
           package.json: el componente nunca estuvo registrado y la paginacion no
           existia. Se reemplaza por vs-pagination, el mismo que usa VxTable. -->
      <vs-pagination
        :total="pageCount"
        :value="page"
        @input="handleChangePage"
      ></vs-pagination>
    </div>
  </div>
</template>

<script>
import Spinner from "vue-simple-spinner";
import PublicationsView from "../../components/modals/Publications/PublicationsView.vue";
import PublicationsAdd from "../../components/modals/Publications/PublicationsAdd.vue";
import FiltersTable from "../../components/filters-table/FiltersTable.vue";
import {
  getAllPublications,
  updatePublications,
} from "../../services/publications.service";

export default {
  name: "Publications",
  data() {
    return {
      publications: [],
      dataView: {},
      dataAdd: {},
      showModalView: false,
      showModalAdd: false,
      showModalActive: false,
      isLoading: false,

      //search
      search: "",

      // pagination
      page: 1,
      totalItems: 0,
      pageCount: 10,
    };
  },
  components: {
    PublicationsView,
    PublicationsAdd,
    FiltersTable,
    Spinner,
  },
  mounted() {
    this.getPublications({ page: this.page });
  },
  filters: {
    toCurrency: function (value) {
      if (typeof value !== "number") {
        return value;
      }
      var formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
      });
      return formatter.format(value);
    },
  },
  methods: {
    async getPublications({ page = 1, search }) {
      this.isLoading = true;
      const { data } = await getAllPublications(page, search);

      this.publications = data.data;

      if (data.meta.total) {
        this.totalItems = data.meta.total;
        this.pageCount = data.meta.last_page;
      }
      this.isLoading = false;
    },
    handleChangePage(page) {
      this.page = page;
      this.getPublications({ page });
    },
    publicationsView(data) {
      this.dataView = data;
      this.showModalView = true;
    },
    handleDataView() {
      this.showModalView = false;
    },
    publicationsAdd(data) {
      console.log(data);
      this.dataAdd = data;
      this.dataAdd.active = false;
      this.showModalAdd = true;
    },
    handleDataAdd() {
      this.showModalAdd = false;
      this.showModalActive = false;
      this.getPublications({});
    },
    publicationsActive(data) {
      this.dataAdd = data;
      this.dataAdd.active = true;
      this.showModalActive = true;
    },
    async getProducts() {
      const response = await updatePublications();
      console.log(response);
      this.getPublications({});
    },
    onSearch(e) {
      if (e.key === "Enter") {
        let search = e.target.value || "";
        this.search = search;
        this.getPublications({ search });
      }
      if (e.key === "Backspace" && e.target.value.length === 1) {
        console.log("entro en back");
        this.getPublications({});
      }
    },
  },
};
</script>
